import styled from 'astroturf/react';

const Form = styled('form')`
  width: 100%;
`;

const FormRow = styled('div')`
  position: relative;
  display: block;
  width: 100%;

  & + & {
    margin-top: 20px;
  }

  &.spaced {
    margin-top: 20px;
  }

  &.inline {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }

  &.collapsed {
    display: none;
  }

  &.withScroll {
    overflow-y: scroll;
    padding-right: 15px;
  }

  &.u-mt-30 {
    margin-top: 30px;
  }
`;

const FormCol = styled('div')`
  flex: 1;

  &.auto {
    flex: 0 0 auto;
  }
`;

export default {
  Form,
  FormRow,
  FormCol,
};
